// Meta (Facebook) Pixel helper.
// Injects the official Meta Pixel base code once, then exposes thin wrappers
// around window.fbq for tracking standard events.

const PIXEL_ID = '896179340192256'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Loads the Meta Pixel base script (idempotent) and initializes the pixel.
 * Safe to call multiple times — only the first call has an effect.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
}

/** Fires a standard PageView event. */
export function trackPageView(): void {
  window.fbq?.('track', 'PageView')
}

/** Fires a standard event (e.g. "AddToCart") with optional parameters. */
export function trackEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  window.fbq?.('track', event, params)
}
